import React from 'react';
import { Grid, Card, Typography, CardMedia, CardContent, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useStyles } from './Card.styles';

interface ICardLinkProps {
  label: string;
  image: string;
  onClick: () => void;
}
export const CardItem = (props: ICardLinkProps) => {
  const classes = useStyles();
  return (
    <Grid item md={3} sm={6} xs={12}>
      <Card className={classes.card}>
        <CardMedia
          className={classes.cardMedia}
          image={props.image}
          style={{ backgroundSize: 'auto', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}
        />
        <CardContent className={classes.cardContent}>
          <Button 
            variant="outlined" 
            onClick={()=>props.onClick()}
            className={`${classes.label} custom-white-space`}
          >
            <FormattedMessage id={props.label} defaultMessage="Module label" description="Module label" />
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};
